import { DocumentList, DocumentUploader } from "./ClaimDocumentsSection";
import { useState } from "react";

/**
 * Bloco de documentos anexos de uma guia (`insurance_claim`).
 *
 * Mostra: "Documentos da guia" com upload + list + view + download + delete.
 * Os procedimentos estruturados (`claim_procedure`) são criados automaticamente
 * ao vincular a guia TISS, mas não há upload por procedimento (por escolha de UX).
 */
export function ClaimDocumentsBlock({
  claimId,
  onChanged,
}: {
  claimId: string;
  onChanged: () => void;
}) {
  const [refreshKey, setRefreshKey] = useState(0);
  const bumpAndNotify = () => { setRefreshKey((k) => k + 1); onChanged(); };

  return (
    <div className="space-y-1.5 pt-1">
      <div className="flex items-center justify-between">
        <p className="text-[10px] text-muted-foreground uppercase tracking-wide font-semibold">Documentos da guia</p>
        <DocumentUploader scope="claim" parentId={claimId} onUploaded={bumpAndNotify} />
      </div>
      <DocumentList scope="claim" parentId={claimId} refreshKey={refreshKey} onChanged={bumpAndNotify} />
    </div>
  );
}
